/**
 * 防抖
 * @param fn
 * @param wait
 * @returns {function(...[*]=)}
 */
export const debounce = (fn, wait) => {
  // 优化版： 定时器执行时，判断start time 是否向后推迟了，若是，设置延迟定时器
  let timer; let startTimeStamp = 0
  let context, args

  const run = (timerInterval) => {
    timer = setTimeout(() => {
      const now = (new Date()).getTime()
      const interval = now - startTimeStamp
      if (interval < timerInterval) { // the timer start time has been reset, so the interval is less than timerInterval
        startTimeStamp = now
        run(wait - interval) // reset timer for left time
      } else {
        fn.apply(context, args)
        clearTimeout(timer)
        timer = null
      }
    }, timerInterval)
  }

  return function() {
    context = this
    args = arguments
    const now = (new Date()).getTime()
    startTimeStamp = now

    if (!timer) {
      run(wait) // last timer alreay executed, set a new timer
    }
  }
}

/**
 * 存localStorage,并加上逻辑时间
 * @param key
 * @param value
 * @param duration 天数
 */
export const setLocal = (key, value, duration) => {
  var data = {
    value: value,
    expiryTime: !duration || isNaN(duration) ? 0 : new Date().getTime() + parseInt(duration * 24 * 60 * 60 * 1000)
  }
  localStorage[key] = JSON.stringify(data)
}
/**
 * 取localStorage,并根据逻辑时间附上有效性
 * @param key
 * @returns {*}
 */
export const getLocal = (key) => {
  var data = localStorage[key]
  if (!data || data === 'null') {
    return null
  }
  var now = new Date().getTime()
  var obj
  try {
    obj = JSON.parse(data)
  } catch (e) {
    return null
  }
  if (obj.expiryTime === 0 || obj.expiryTime > now) {
    return obj.value
  }
  return null
}
/**
 * 删除LocalStorage
 * @param key
 */
export const removeLocal = (key) => {
  localStorage.removeItem(key)
}

/**
 * 存sessionStorage,并加上逻辑时间
 * @param key
 * @param value
 * @param duration 天数
 */
export const setSession = (key, value, duration) => {
  var data = {
    value: value,
    expiryTime: !duration || isNaN(duration) ? 0 : new Date().getTime() + parseInt(duration * 24 * 60 * 60 * 1000)
  }
  sessionStorage[key] = JSON.stringify(data)
}
/**
 * 取sessionStorage,并根据逻辑时间附上有效性
 * @param key
 * @returns {*}
 */
export const getSession = (key) => {
  var data = sessionStorage[key]
  if (!data || data === 'null') {
    return null
  }
  var now = new Date().getTime()
  var obj
  try {
    obj = JSON.parse(data)
  } catch (e) {
    return null
  }
  if (obj.expiryTime === 0 || obj.expiryTime > now) {
    return obj.value
  }
  return null
}
/**
 * 删除sessionStorage
 * @param key
 */
export const removeSession = (key) => {
  sessionStorage.removeItem(key)
}
/**
 * 简单数组去重
 * @param array
 * @returns {Array}
 */
export const unRepeat = (array) => {
  const temp = [] // 一个新的临时数组
  for (let i = 0; i < array.length; i++) {
    if (temp.indexOf(array[i]) === -1) {
      temp.push(array[i])
    }
  }
  return temp
}

export const ellipsis = (str, n) => {
  return str.length > n ? str.slice(0, n) + '...' : str
}
/**
 * 保留小数点几位
 * @param num
 * @param n
 * @returns {string}
 */
export const spotN = (num, n = 2) => {
  return parseFloat(num).toFixed(n)
}

function isObject(obj) {
  return typeof obj === 'object' && obj !== null
}
/**
 * 深拷贝
 * @param orig
 * @returns {any}
 */
export const deepCopy = (source) => {
  if (!isObject(source)) return source // 如果不是对象的话直接返回
  const target = Array.isArray(source) ? [] : {} // 数组兼容
  for (var k in source) {
    if (source.hasOwnProperty(k)) {
      if (typeof source[ k ] === 'object') {
        target[ k ] = deepCopy(source[ k ])
      } else {
        target[ k ] = source[ k ]
      }
    }
  }
  return target
}
export const easyCopy = (source) => {
  setSession('zhj_easyCopy', source)
  return getSession('zhj_easyCopy')
}

/**
 * 随机字符串
 * @param size
 * @returns {string}
 */
export const randomStr = (size) => {
  const seed = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '2', '3', '4', '5', '6', '7', '8', '9']
  let str = ''
  for (let i = 0; i < size; i++) {
    str += seed[Math.floor(Math.random() * seed.length)]
  }
  return str
}

export const mergeArrToObj = (keyArr, valueArr) => {
  const obj = {}
  keyArr.map((v, i) => {
    obj[keyArr[i]] = valueArr[i] || ''
  })
  return obj
}

export const fileDownload = (content, filename) => {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement('a')
  eleLink.download = filename
  eleLink.style.display = 'none'
  // 字符内容转变成blob地址
  var blob = new Blob([content])
  eleLink.href = URL.createObjectURL(blob)
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

// 字符串转base64
export const encode = (str) => {
  // 对字符串进行编码
  // 对编码的字符串转化base64
  return btoa(encodeURI(str))
}
// base64转字符串
export const decode = (base64) => {
  // 对base64转编码
  // 编码转字符串
  return decodeURI(atob(base64))
}
export const b64EncodeUnicode = (str) => {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function(match, p1) {
      return String.fromCharCode('0x' + p1)
    }))
}

export const objDeleteId = (arr, id, children = 'children') => {
  return deleteId(arr, id, children)
}
function deleteId(arr, id, children = 'children') {
  const temp = arr.findIndex(item => item.id === id)
  if (temp === -1) {
    arr.forEach(item => {
      if (item[children] && item[children].length) {
        item[children] = deleteId(item[children], id, children)
      }
    })
  } else {
    arr.splice(temp, 1)
  }
  return arr
}
function find(arr, fn, result, children = 'children') {
  arr.forEach(item => {
    if (item[children]) {
      find(item[children], fn, result)
    }
    if (fn(item)) {
      result.push(item)
    }
  })
}
export const findId = (arr, fn, result, children = 'children') => {
  find(arr, fn, result, children)
}
